import { Text, HStack } from '@genial/components';
import React from 'react';

import { CustomerDuckCopyIcon } from '../CustomerDuckCopyIcon';
import { CustomerDuckRightIcon } from '../CustomerDuckRightIcon';

type RightIconType = 'success' | 'warning' | 'error';

export interface CustomerDuckValueProps {
  value?: string;
  mobileValue?: string;
  valueRightIcon?: RightIconType;
  copyValue?: string;
  opaque?: boolean;
}

export const CustomerDuckValue: React.FC<CustomerDuckValueProps> = ({
  value,
  valueRightIcon,
  copyValue,
  opaque,
}) => {
  if (!value) {
    return null;
  }

  return (
    <HStack space={valueRightIcon ? 'stack.quarck' : undefined} alignItems="center" flexWrap="wrap">
      <Text color={opaque ? 'neutral.medium' : 'neutral.black'}>{value}</Text>
      {valueRightIcon && <CustomerDuckRightIcon type={valueRightIcon} />}
      {copyValue && <CustomerDuckCopyIcon valueToCopy={copyValue} />}
    </HStack>
  );
};
